import style from "../../style";
import styled from "styled-components";

export const Error = styled.div`
  display: ${({ children }) => (!!children ? "flex" : "none")};
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  margin-top: 10px;
  margin-bottom: 30px;
  color: ${style.input.error.border};
`;

